export class TokenProcessingGateway {
    constructor(tokenStream) {
        this.tokenStream = tokenStream;
    }
    start(token) {
        if (this.streamPromise) {
            this.stop();
        }
        this.cancellationSource = { isCancelled: false };
        this.streamPromise = this.tokenStream.run(token, this.cancellationSource);
    }
    stop() {
        if (this.cancellationSource) {
            this.cancellationSource.isCancelled = true;
        }
        this.streamPromise = undefined;
    }
}
//# sourceMappingURL=TokenProcessingGateway.js.map